

import axios, { AxiosRequestConfig } from 'axios';
import { CompanyIdHoursRequest, FreebieIdRequest, FreebieRequest, FreebiesResponse, CompanyIdRequest, empDeptRequest } from '@gtpl/shared-models/canteen-management'
import { connection } from '../../freebies-management';

export class FreebiesServices {
    URL = connection.DEPLOY_URL + '/freebies'

    async createFreebie(freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/createFreebie', freebiesReq)
            .then(res => {
                return res.data
            })
    }

    async updateFreebie(freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        console.log('jii'+freebiesReq)
        return await axios.post(this.URL + '/updateFreebie', freebiesReq)
            .then(res => {
                return res.data
            })
    }

    async getFreebiesByCompanyId(companyIdReq: CompanyIdRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getFreebiesByCompanyId', companyIdReq)
            .then(res => {
                return res.data
            })
    }

    
  async getAllActiveFreebies(): Promise<FreebiesResponse> {
    return await axios.post(this.URL + '/getAllActiveFreebies')
      .then(res => {
        return res.data
      })
  }

    async getAllFreebies(): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getAllFreebies')
            .then(res => {
                return res.data
            })
    }

    async ActivateorDeactivateFreebies(freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        console.log(freebiesReq);
        return await axios.post(this.URL + '/ActivateorDeactivateFreebies', freebiesReq)
          .then(res => {
            return res.data
          })
      }

    async getFreebieById(freebieIdReq: FreebieIdRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getFreebieById',freebieIdReq)
            .then(res => {
                return res.data
            })
    }

    async getReportData(req?:empDeptRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getReportData',req)
            .then(res => {
                return res.data
            })
    }

    async deleteFreebieById(freebieIdReq: FreebieIdRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/deleteFreebieById',freebieIdReq)
            .then(res => {
                return res.data
            })
    }

    async getFreebieForCompanyAndHours(companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getFreebieForCompanyAndHours',companyIdHourReq)
            .then(res => {
                return res.data
            })
    }

    async getFreebieForCurrentJobHour(companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        return await axios.post(this.URL + '/getFreebieForCurrentJobHour',companyIdHourReq)
            .then(res => {
                return res.data
            })
    }

}